import { apiFetch } from './api';

export class Telemetry {
  constructor(type = 'mixpanel') {
    const telemetries = {
      mixpanel: {
        init: () => { },
        track: async (eventName, properties) => apiFetch('/api/v1/telemetry/mp/', {
          method: 'POST',
          body: JSON.stringify({ eventName, properties }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
          },
        }),
      },
    };
    this.currentTelemetry = telemetries[type];
    this.currentTelemetry.init();
  }
  async track(eventName, properties) {
    await this.currentTelemetry.track(eventName, properties);
  }
}

export default (new Telemetry);
